import "./../styles.scss";
import "./../styles.scss";

import {
  CopyOutlined,
  EditOutlined,
  LoadingOutlined,
  PoweroffOutlined,
  ProfileOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";
import { Dropdown, notification, Pagination, Select, Tooltip } from "antd";
import { ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import Select2 from "react-select";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import AntdSpinner from "../../../components/common/AntdSpinner/antd-spinner";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import amplitude from "../../../externals/amplitude";
import { addChannelValidation } from "../../../utils/validations";
import { editChannelValidation } from "../../../utils/validations";
import EditChannel from "./EditChannel";

const AddChannel = (props) => {
  const {
    usersDetails,
    setUserSearch,
    deleteRTMPChannel,
    userSearch,
    userId,
    setLoder,
    loder,
    user,
    updatertmpChannel,
    updateRTMPState,
    setNotify,
    notify,
    allUsers,
    setAllUsers,
    getInviteUser,
    createRTMPChannel,
    getRTMPChannel,
    getChannelDetails,
    fetchUsersByUserIds,
    getOrgDetails,
    getOrganizationsByIds,
    id,
  } = props;
  const { Option } = Select;
  const firstRef = useRef(true);
  const orgSearch = useRef(true);

  const [delLoder, setDelLoder] = useState(false);
  const [options, setoptions] = useState([]);
  const [count, setCount] = useState(0);
  const [configData, setConfigData] = useState();
  const [editChannelDetail, setEditChannelDetail] = useState(null);
  const [editConfigOpen, setEditConfigOpen] = useState(false);
  const [channels, setChannels] = useState([]);
  const [channelId, setChannelId] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [editOpen, setEditOpen] = useState(false);
  const [selectOrganization, setSelectOrganization] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [configmodalOpen, setConfigModalOpen] = useState(false);
  const [settingsRecordsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [copiedUrl, setCopiedUrl] = useState("");
  const [organizationLists, setOrganizationLists] = useState([]);
  const { entityId, currentRole } = useOutletContext();
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [initialState] = useState({
    channelName: "",
    channelid: "",
    region: "",
    cdn_suffix: "",
    access_key: "",
    secret_key: "",
    organization: "",
  });
  const [initialConfigDetails, setInitialConfigDetails] = useState({
    cdn_path: "",
    destination: "",
    folder_path: "",
    output_url: "",
    frame_rate: 0,
    bitrate: 0,
  });
  useEffect(() => {
    if (configData) {
      setInitialConfigDetails({
        cdn_path: configData?.cdn_suffix,
        destination: configData?.destinationUrl,
        folder_path: getUrlData(configData?.destinationUrl)?.folder_path,
        output_url: getOutputUrl(configData?.cdn_suffix, configData?.destinationUrl),
        frame_rate: configData?.frameRate,
        bitrate: configData?.bitrate,
      });
    }
  }, [configData]);
  const openModal = () => {
    setIsOpen(true);
    amplitude.logEvent("add_channel");
  };

  const delOpen = (data) => {
    setChannelId(data?._id);
    setDeleteModalOpen(true);
  };
  const configOpen = () => {
    setConfigModalOpen(true);
  };
  const configEditOpen = () => {
    if (configData?.channelState !== "IDLE") {
      notification["warning"]({ message: "Channel can only be updated in Idle State!" });
    } else if (configData) {
      setEditConfigOpen(true);
    }
  };

  const closeEditModal = () => {
    setEditConfigOpen(false);
  };
  //Get All OrganizationsLists
  const getOrganizationsDetails = async () => {
    const { value } = await getOrgDetails({
      page_no: 1,
      pageSize: 10,
      searchQuery: organizationSearch,
    });
    if (value?.status) {
      setOrganizationLists(value?.organizations || []);
    }
  };
  const closeModal = () => {
    setSelectOrganization([]);
    setNotify(false);
    setIsOpen(false);
  };
  const onClose = () => {
    setConfigModalOpen(false);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const deleteChannelModel = async () => {
    setDelLoder(true);
    const { value } = await deleteRTMPChannel(channelId);
    if (value?.status) {
      delclose();
      notification["success"]({ message: value.message });
    } else {
      delclose();
      notification["error"]({ message: value.message });
    }
    fetchChannels();
    setDelLoder(false);
  };

  const handleChange = (e) => {
    setSelectOrganization(e);
  };

  useEffect(() => {
    const options = [];
    organizationLists &&
      organizationLists.map((org) => {
        options.push({ value: org?.organizationId, label: org.name });
      });
    setoptions(options);
  }, [organizationLists]);

  useEffect(() => {
    if (user?.role === ROLE.SUPER_ADMIN) {
      getOrganizationsDetails();
    }
  }, []);

  useEffect(() => {
    getInviteUser(false);
  }, [count]);

  const fetchChannels = async () => {
    setLoader(true);
    const data = await getRTMPChannel({
      // userId,
      page_no: activePage,
      limit: 10,
      entityId: id, //for superadmin, keep orgId as ''
    });
    if (data?.value?.status) {
      setTotalCount(data?.value?.channelCount);
      setChannels(data?.value?.data);
    } else {
      notification["error"]({ message: data?.value?.message });
    }
    setLoader(false);
  };
  useEffect(() => {
    fetchChannels();
  }, [id]);

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [userSearch]);
  useEffect(() => {
    if (orgSearch.current) {
      orgSearch.current = false;
    } else {
      const timer = setTimeout(() => {
        if (user?.role === ROLE.SUPER_ADMIN) {
          getOrganizationsDetails();
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [organizationSearch]);

  const handleSubmit = async (values) => {
    setLoder(true);
    const { value } = await createRTMPChannel({
      channelName: values?.channelName,
      channelId: values?.channelid,
      type: "create",
      creds: {
        region: values?.region,
        accessKey: values?.access_key,
        secretAccessKey: values?.secret_key,
      },
      cdn_suffix: values?.cdn_suffix,
      entityId: id,
    });
    if (value.status == true) {
      notification["success"]({ message: value.message });
      setNotify(false);
      closeModal();
    } else if (value.status == false && value.message == "Channel Already Exists!") {
      setNotify(true);
    } else {
      notification["error"]({ message: value.message });
    }
    fetchChannels();
    setSelectOrganization([]);
    setLoder(false);
    amplitude.logEvent("channel_added", { channel_id: values?.channelid, channel_name: values?.channelName });
  };

  const handleEditSubmit = async (values) => {
    setLoder(true);
    const { value } = await updatertmpChannel({
      channelId: configData?.channelId,
      userId,
      destinationUrl: values?.destination,
      cdn_suffix: values?.cdn_path,
      frame_rate: values?.frame_rate,
      bitrate: values?.bitrate,
    });
    if (value.status) {
      notification["success"]({ message: value.message });
      setNotify(false);
    } else {
      notification["error"]({ message: value.message });
    }
    closeEditModal();
    fetchChannels();
    setLoder(false);
  };

  useEffect(() => {
    fetchChannels();
  }, [activePage]);

  const EditOpen = () => {
    setEditOpen(true);
  };

  const handleClick = async (data) => {
    setEditChannelDetail(data);
    if (data?.user?.length !== 0) {
      fetchUsersByUserIds([data?.user]);
    }
    setConfigData(data);
  };

  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };

  const actions = {
    update_channel: true,
    edit_channel: true,
    view_channel: true,
    edit_channelDetails: true,
    delete_channel: true,
  };

  const handleChannelTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "update_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    handletoggle(
                      editChannelDetail?.state?.toLowerCase() === "start" ? false : true,
                      editChannelDetail?.channelId,
                    );
                    amplitude.logEvent("channel_menu_clicked", { item: "start_stop_channel" });
                  }}
                >
                  <PoweroffOutlined />
                  <span>{editChannelDetail?.state?.toLowerCase() === "start" ? "Stop Channel" : "Start Channel"}</span>
                </a>
              ),
              key: "4",
            });
            break;
          case "view_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    configOpen();
                    amplitude.logEvent("channel_menu_clicked", { item: "view_channel" });
                  }}
                >
                  <ProfileOutlined />
                  <span>Configuration Details</span>
                </a>
              ),
              key: "0",
            });
            break;
          case "edit_channelDetails":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    configEditOpen();
                    amplitude.logEvent("channel_menu_clicked", { item: "edit_channel_configuration" });
                  }}
                >
                  <EditOutlined />
                  <span>Edit Channel Configuration</span>
                </a>
              ),
              key: "3",
            });
            break;
          case "edit_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    EditOpen();
                    amplitude.logEvent("channel_menu_clicked", { item: "edit_channel" });
                  }}
                >
                  <EditOutlined />
                  <span>Edit Channel</span>
                </a>
              ),
              key: "1",
            });
            break;
          case "delete_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    delOpen(editChannelDetail);
                    amplitude.logEvent("channel_menu_clicked", { item: "delete_channel" });
                  }}
                >
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              ),
              key: "2",
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const handletoggle = async (e, channelId) => {
    const value = await updateRTMPState({
      userId,
      channelId,
      channelAction: e ? "start" : "stop",
    });
    if (value?.value?.status) {
      notification["success"]({ message: value?.value?.message });
      fetchChannels();
    } else {
      notification["error"]({ message: value?.value?.message });
    }
  };

  const handlePageChange = (current) => {
    setActivePage(current);
    amplitude.logEvent("channel_pagination", { page: current });
  };

  const getOutputUrl = (cdn_suffix, url) => {
    if (url && cdn_suffix) {
      // Split the URI by "/"
      const parts = url?.split("/");

      return cdn_suffix + "hls/" + parts[4] + "/master_hightest.m3u8";
    } else {
      return "";
    }
  };

  const getUrlData = (url) => {
    if (url) {
      // Split the URI by "/"
      const parts = url?.split("/");

      return {
        s3Prefix: parts.slice(0, 4).join("/") + "/",
        folder_path: parts[4],
        mainFolder: parts[5],
      };
    } else {
      return null;
    }
  };

  const handleDestinationChange = (e, setFieldValue, destinationUrl) => {
    setFieldValue("folder_path", e.target.value);
    const url = getUrlData(destinationUrl);
    const finalUrl = url?.s3Prefix + e.target.value + "/" + url?.mainFolder;
    const outputUrl = getOutputUrl(configData?.cdn_suffix, finalUrl) || "";
    setFieldValue("destination", finalUrl);
    setFieldValue("output_url", outputUrl);
    setInitialConfigDetails({ ...initialConfigDetails, destination: finalUrl, output_url: outputUrl });
  };

  const handleRefresh = async (data) => {
    const value = await getChannelDetails({ channelId: data.channelId });
    if (value?.value?.status) {
      let channel = [...channels];
      const index = channel.findIndex(({ channelId }) => channelId === (data?.channelId || ""));
      if (index !== -1) {
        channel[index] = value?.value?.data || null;
        setChannels([...channel]);
        notification["success"]({ message: "Channel Updated Successfully!" });
      }
    }
    amplitude.logEvent("refresh_channel", { channel_id: data?.channelId, channel_name: data?.channelName });
  };
  const handleCopyClick = (data, index) => {
    const channelArray = [...channels];
    const urlToCopy = getOutputUrl(data?.cdn_suffix, data?.destinationUrl);

    navigator.clipboard
      .writeText(urlToCopy)
      .then(() => {
        // Set urlCopied to true for the specified index
        data["urlCopied"] = true;
        setCopiedUrl(urlToCopy);
        // Set urlCopied to false for other objects where it is true
        channelArray.forEach((item, i) => {
          if (i !== index && item.urlCopied) {
            item.urlCopied = false;
          }
        });

        setChannels([...channelArray]);
        setIsCopied(false);
      })
      .catch((err) => {
        // Handle any errors that occurred during the copy operation
        notification.error({ message: "Failed to copy URL" });
      });
    amplitude.logEvent("copy_channel_url", { channel_id: data?.channelId, channel_name: data?.channelName });
  };

  const handleCopyLink = () => {
    const urlToCopy = getOutputUrl(configData?.cdn_suffix, configData?.destinationUrl);
    navigator.clipboard.writeText(urlToCopy);
    setCopiedUrl(urlToCopy);
    setIsCopied(true);
  };
  return (
    <>
      <EditChannel
        options={options}
        setEditOpen={setEditOpen}
        modalIsOpen={modalIsOpen}
        initialState={initialState}
        allUsers={allUsers}
        getInviteUser={getInviteUser}
        setAllUsers={setAllUsers}
        handleChange={handleChange}
        setUserSearch={setUserSearch}
        loder={loder}
        notify={notify}
        setNotify={setNotify}
        userSearch={userSearch}
        setLoder={setLoder}
        createRTMPChannel={createRTMPChannel}
        fetchChannels={fetchChannels}
        editOpen={editOpen}
        editChannelDetail={editChannelDetail}
        getOrganizationsByIds={getOrganizationsByIds}
        setOrganizationSearch={setOrganizationSearch}
        id={id}
      />
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={delmodalOpen}
        loder={delLoder}
        deleteComanModel={deleteChannelModel}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      {/* User Edit Modal */}
      <Modal
        isOpen={editConfigOpen}
        onRequestClose={closeEditModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-s modal-dialog-centered"
      >
        <div className="modal-content">
          {/* <AccessControl code="add_team" page="organization-profile"> */}
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Channel Configuration</h5>
            <button type="button" onClick={closeEditModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          {/* </AccessControl> */}
          <Formik
            initialValues={initialConfigDetails}
            validationSchema={editChannelValidation}
            onSubmit={handleEditSubmit}
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        CDN Path<span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="cdn_path"
                        type="text"
                        placeholder="Enter Path"
                        disabled={true}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Destination<span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="folder_path"
                        type="text"
                        placeholder="Enter Url"
                        onChange={(e) => handleDestinationChange(e, setFieldValue, initialConfigDetails?.destination)}
                      />
                      {touched.folder_path && errors.folder_path && (
                        <div className="invalid-feedback">{errors.folder_path}</div>
                      )}
                      <label className="form-label">{initialConfigDetails?.destination}</label>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Output Url
                        <Tooltip
                          title={isCopied && initialConfigDetails.output_url === copiedUrl ? "Copied" : "Copy Link"}
                        >
                          {<CopyOutlined onClick={() => handleCopyLink()} />}
                        </Tooltip>
                      </label>
                      <Field
                        className="form-control"
                        name="output_url"
                        value={initialConfigDetails.output_url}
                        type="text"
                        placeholder="Enter Url"
                        disabled={true}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Frame Rate<span className="required">*</span>
                      </label>
                      <Field className="form-control" name="frame_rate" type="number" placeholder="Enter Frame Rate" />
                      {touched.frame_rate && errors.frame_rate && (
                        <div className="invalid-feedback">{errors.frame_rate}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Bitrate<span className="required">*</span>
                      </label>
                      <Field className="form-control" name="bitrate" type="number" placeholder="Enter Bitrate" />
                      {touched.bitrate && errors.bitrate && <div className="invalid-feedback">{errors.bitrate}</div>}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeEditModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Edit
                        {<AntdSpinner spin={loder} style={{ fontSize: 25, color: "#000", marginLeft: 25 }} />}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      {/* Create New Channel Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          {/* <AccessControl code="add_team" page="organization-profile"> */}
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Channel</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          {/* </AccessControl> */}
          <Formik initialValues={initialState} validationSchema={addChannelValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Channel Id <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="channelid"
                        type="text"
                        placeholder="Enter Channel Id"
                        value={values.channelid}
                        onChange={(e) => handlChange(setFieldValue, e)}
                      />
                      {notify && <div className="invalid-feedback">channel id already exists!</div>}
                      {touched.channelid && errors.channelid && (
                        <div className="invalid-feedback">{errors.channelid}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Channel Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="channelName" type="text" placeholder="Enter Channel Name" />
                      {touched.channelName && errors.channelName && (
                        <div className="invalid-feedback">{errors.channelName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Region <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="region" type="text" placeholder="Enter Region" />
                      {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        CDN Suffix <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="cdn_suffix" type="text" placeholder="Enter CDN Suffix" />
                      {touched.cdn_suffix && errors.cdn_suffix && (
                        <div className="invalid-feedback">{errors.cdn_suffix}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Secret Key <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="secret_key" type="text" placeholder="Enter Secret key" />
                      {touched.secret_key && errors.secret_key && (
                        <div className="invalid-feedback">{errors.secret_key}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Access Key <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="access_key" type="text" placeholder="Enter Access key" />
                      {touched.access_key && errors.access_key && (
                        <div className="invalid-feedback">{errors.access_key}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Organizations<span className="required"></span>
                      </label>
                      <Select2
                        styles={{ width: "100%" }}
                        // isMulti={true}
                        bordered={false}
                        value={selectOrganization}
                        isClearable={true}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onInputChange={(e) => {
                          setOrganizationSearch(e);
                        }}
                        name="organization"
                        options={options}
                      />
                      {/* {touched.user && errors.user && <div className="invalid-feedback">{errors.user}</div>} */}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      {/* RTMP List page */}
      <div>
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">RTMP Channels</h4>
          </div>
          {currentRole === ROLE.SUPER_ADMIN && (
            <div className="right-btn-block">
              <div className="button-container">
                <button className="btn btn-primary" onClick={openModal}>
                  Add Channels
                </button>
              </div>
            </div>
          )}
        </div>
        <br />
        <div className="border-block mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table normal-table-block">
                <table className="table">
                  <>
                    <thead>
                      <tr>
                        <th>Channel Name</th>
                        <th>Status</th>
                        <th>Channel Id</th>
                        <th>Input Type</th>
                        <th>Push Point</th>
                        <th>Output Url</th>
                        <th style={{ textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loader ? (
                        <>
                          <tr>
                            <td colSpan="7">
                              <div className="text-center  pt-5 pb-5">
                                <h3>Fetching RTMP Channels</h3>
                              </div>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          {channels?.length ? (
                            channels?.map((data, index) => {
                              return (
                                <tr key={data?._id}>
                                  <td>
                                    <div
                                      className={
                                        data?.channelState === "IDLE"
                                          ? "yellow-dot"
                                          : data?.channelState === "RUNNING"
                                            ? "green-dot"
                                            : "red-dot"
                                      }
                                    ></div>
                                  </td>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <Tooltip
                                      title={data?.channelName}
                                      placement={"bottomLeft"}
                                      className="word-break-two title_Pascal"
                                    >
                                      {data?.channelName}
                                    </Tooltip>
                                  </td>
                                  <td>{data?.channelState}</td>
                                  <td>{data?.channelId}</td>
                                  <td>{data?.inputType?.replace("_", " ")}</td>
                                  <td>{data?.inputUrl}</td>
                                  <td>
                                    {getOutputUrl(data?.cdn_suffix, data?.destinationUrl)}
                                    <Tooltip
                                      title={
                                        data?.urlCopied &&
                                        getOutputUrl(data?.cdn_suffix, data?.destinationUrl) === copiedUrl
                                          ? "Copied"
                                          : "Copy Link"
                                      }
                                    >
                                      {<CopyOutlined onClick={() => handleCopyClick(data, index)} />}
                                    </Tooltip>
                                  </td>
                                  <td>
                                    <div className="table-action-block text-center">
                                      <Dropdown
                                        onClick={() => {
                                          handleClick(data);
                                        }}
                                        className=""
                                        overlay={
                                          <AccessControl
                                            code="menuItem"
                                            page="organization-profile"
                                            handleTableAction={handleChannelTableAction}
                                          />
                                        }
                                        trigger={["click"]}
                                        overlayClassName={"tableActionBlock"}
                                        placement={"bottomRight"}
                                      >
                                        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                          <TheeDotsIcon />
                                        </a>
                                      </Dropdown>
                                    </div>
                                  </td>
                                  <td>
                                    <ReloadOutlined onClick={() => handleRefresh(data)} />
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <>
                              <tr>
                                <td colSpan="7">
                                  <div className="text-center  pt-5 pb-5">
                                    <h3>No Channels found</h3>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      )}
                    </tbody>
                  </>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={totalCount}
          className="text-center mt-3"
        />
      </div>

      {/* Configuration Details Modal */}
      <Modal
        isOpen={configmodalOpen}
        ariaHideApp={false}
        onRequestClose={onClose}
        contentLabel="Delete Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-lg modal-dialog-centered filter-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Configuration Details</h5>
            <button type="button" onClick={onClose} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <div className="react-modal-body">
            <div className="inner-container content-control-block styled-scroll">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-resposive table-container">
                    <table className="table sr-table-view">
                      <tbody>
                        <tr>
                          <td>Channel Name</td>
                          <td>{configData?.channelName}</td>
                        </tr>
                        <tr>
                          <td>Channel Id</td>
                          <td>{configData?.channelId}</td>
                        </tr>
                        <tr>
                          <td>Region</td>
                          <td>{configData?.region}</td>
                        </tr>
                        <tr>
                          <td>State</td>
                          <td>{configData?.channelState}</td>
                        </tr>
                        <tr>
                          <td>Bitrate</td>
                          <td>{configData?.bitrate}</td>
                        </tr>
                        <tr>
                          <td>Width</td>
                          <td>{configData?.width}</td>
                        </tr>
                        <tr>
                          <td>Height</td>
                          <td>{configData?.height}</td>
                        </tr>
                        <tr>
                          <td>Frame Rate</td>
                          <td>{configData?.frameRate}</td>
                        </tr>
                        <tr>
                          <td>Input Url</td>
                          <td>{configData?.inputUrl}</td>
                        </tr>
                        <tr>
                          <td>CDN Path</td>
                          <td>{configData?.cdn_suffix}</td>
                        </tr>
                        <tr>
                          <td>Destination Name</td>
                          <td>{configData?.inputId}</td>
                        </tr>
                        <tr>
                          <td>Destination URL</td>
                          <td>{configData?.destinationUrl}</td>
                        </tr>
                        <tr>
                          <td>Output URL</td>
                          <td>
                            {getOutputUrl(configData?.cdn_suffix, configData?.destinationUrl)}{" "}
                            <Tooltip
                              title={
                                isCopied &&
                                getOutputUrl(configData?.cdn_suffix, configData?.destinationUrl) === copiedUrl
                                  ? "Copied"
                                  : "Copy Link"
                              }
                            >
                              <CopyOutlined onClick={() => handleCopyLink()} />
                            </Tooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>Last Session</td>
                          <td>
                            {moment().startOf("day").seconds(parseInt(configData?.session)).format("H:mm:ss")} min
                          </td>
                        </tr>
                        <tr>
                          <td>Total Consumption</td>
                          <td>
                            {moment().startOf("day").seconds(parseInt(configData?.totalConsumption)).format("H:mm:ss")}{" "}
                            min
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddChannel;
